import React from 'react'
import PropTypes from 'prop-types'

import { Box, Tooltip, Menu, useTheme } from '@mui/material'
import { StaticDateRangePicker } from '@mui/x-date-pickers-pro/StaticDateRangePicker'

import { get } from 'utils/lodash'
import CancelButton from 'components/buttons/CancelButton'
import SaveButton from 'components/buttons/SaveButton'

const DatePickerMenu = ({ anchorEl, dateRange = [], shortcutsItems = [], onCalendarChange, onSave, onCalendarClose }) => {
  const theme = useTheme()
  const isOpen = Boolean(anchorEl)
  const hasDateRangeStartDate = Boolean(get(dateRange, '0'))

  return (
    <Menu
      anchorEl={anchorEl}
      open={isOpen}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={onCalendarClose}
      sx={{ zIndex: theme.zIndex.tooltip }}
    >
      <StaticDateRangePicker
        value={dateRange}
        slotProps={{
          shortcuts: {
            items: shortcutsItems,
          },
          actionBar: { actions: [] },
        }}
        calendars={2}
        onChange={onCalendarChange}
      />

      <Box display="flex" justifyContent="flex-end" borderTop="1px solid" borderColor="divider" p={2}>
        <CancelButton onClick={onCalendarClose} />
        <Tooltip title="Select date range" arrow placement="top" disableInteractive disableHoverListener={hasDateRangeStartDate}>
          <span>
            <SaveButton disabled={!hasDateRangeStartDate} onClick={onSave} />
          </span>
        </Tooltip>
      </Box>
    </Menu>
  )
}

DatePickerMenu.propTypes = {
  anchorEl: PropTypes.object,
  dateRange: PropTypes.array,
  shortcutsItems: PropTypes.array,
  onCalendarChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCalendarClose: PropTypes.func.isRequired,
}

export default DatePickerMenu
